import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Nav } from 'react-bootstrap';
import { getQuestionBlockData } from '../../containers/SurveyBuilder/utils';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { QuestionSection } from '../../../../common/enums/QuestionSection';

interface IProps {
 type: QuestionSection;
 onChangeTab: IBindingCallback1<QuestionSection>;
}

const SurveyBuilderTab: FunctionComponent<IProps> = ({ type, onChangeTab }) => {
  const { icon } = getQuestionBlockData(type);

  return (
    <Nav.Item className="tab">
      <Nav.Link className="tab-link t-14" onSelect={key => onChangeTab(key as QuestionSection)} eventKey={type}>
        {icon}
        <FormattedMessage id={type} defaultMessage={type} />
      </Nav.Link>
    </Nav.Item>
  );
};

export default SurveyBuilderTab;
